export default "__VITE_ASSET__mi9wg31m__"